module.exports = "pegasus/assets/themelp1/ebook/106.png";